import { LayerSpecification } from 'maplibre-gl';
import { MapSourceId } from '@daisi/models/map';
import { IncidentIconService } from '@services/map/incident-icon.service';
import { getIconImageForMap } from '@services/map/incident-icon-images';

export const DAISI_SOURCE: MapSourceId = 'daisi';
export const DAISI_POPUP_INCIDENT_SOURCE: MapSourceId = 'daisi-popup-incident';
export const DAISI_INACTIVE_SOURCE: MapSourceId = 'daisi-inactive';

export const DAISI_LAYER: LayerSpecification = {
  id: 'daisiPoints',
  type: 'symbol',
  source: DAISI_SOURCE,
  layout: {
    'icon-image': [
      'concat',
      'incident_',
      ['get', 'incidentStatus'],
      '_',
      getIconImageForMap(IncidentIconService.DATEX_TYPE_TO_MAP_ICON_MAP, 'ndw-im-other-red-25'),
      '_',
      ['get', 'daisiLevelOfPersistence'],
      '_',
      IncidentIconService.NORMAL_SIZE,
    ],
    'icon-allow-overlap': true,
  },
};

export const DAISI_POPUP_INCIDENT_LAYER: LayerSpecification = {
  id: 'daisiPopupIncidentPoints',
  type: 'symbol',
  source: DAISI_POPUP_INCIDENT_SOURCE,
  layout: {
    'icon-image': [
      'concat',
      'incident_',
      ['get', 'incidentStatus'],
      '_',
      getIconImageForMap(IncidentIconService.DATEX_TYPE_TO_MAP_ICON_MAP, 'ndw-im-other-red-25'),
      '_',
      ['get', 'daisiLevelOfPersistence'],
      '_',
      IncidentIconService.LARGE_SIZE,
    ],
    'icon-allow-overlap': true,
  },
};

export const DAISI_INACTIVE_LAYER: LayerSpecification = {
  id: 'daisiInactivePoints',
  type: 'symbol',
  source: DAISI_INACTIVE_SOURCE,
  layout: {
    'icon-image': getIconImageForMap(
      IncidentIconService.DATEX_TYPE_TO_INACTIVE_MAP_ICON_MAP,
      'ndw-other-25',
    ),
    'icon-allow-overlap': true,
  },
  paint: {
    'icon-opacity': 0.5,
  },
  filter: ['all', ['==', '$type', 'Point']],
};
